import axios from "axios";

/**
 * Configuración de variables de entorno:
 * 
 * 1. En tiempo de ejecución (Docker): window._env_.REACT_APP_BASEURL
 *    - Se inyecta desde docker-entrypoint.sh
 *    - Permite cambiar la URL sin recompilar
 * 
 * 2. En tiempo de build: process.env.REACT_APP_BASEURL
 *    - Se lee desde archivos .env durante el build
 * 
 * 3. Fallback: URL por defecto
 */
function getBaseURL() {
  // Prioridad: window._env_ (variables de entorno en tiempo de ejecución)
  if (window._env_?.REACT_APP_BASEURL) {
    return window._env_.REACT_APP_BASEURL;
  }
  
  // Fallback: process.env (variables de entorno en tiempo de build)
  if (process.env.REACT_APP_BASEURL) {
    return process.env.REACT_APP_BASEURL;
  }
  
  // Fallback final: URL por defecto
  return "https://be-dev.limsoil.com/";
}

export const tokenAxios = (valueToken) => {
  return valueToken ? valueToken : "";
};

// Crear la instancia de axios sin establecer `baseURL` inicialmente
const instance = axios.create({
  withCredentials: false,
});

// Interceptor para configurar `baseURL` dinámicamente en cada solicitud
instance.interceptors.request.use(
  config => {
    config.baseURL = getBaseURL();  // Asigna `baseURL` en cada solicitud
    const token = tokenAxios(localStorage.getItem('token'));
    if (token) {
      config.headers.Authorization = `basic ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default instance;
